
import { Stack } from '@client/shared/design';
import { Bookings, Schedule } from '@client/features/scheduling';
import { useCurrentUser } from '@client/shared/auth';
import { Listings } from './Listings/index.ts';

export function Home() {
  // Literal role check, not the hasRole ladder: only users with the agent role get
  // bookings of their own, so everyone else sees the group-wide Bookings calendar.
  const isAgent = useCurrentUser()?.roles.includes('agent') ?? false;
  return (
    <Stack gap={9}>
      <section aria-label={isAgent ? 'Your schedule' : 'Bookings'}>
        {isAgent ? <Schedule /> : <Bookings />}
      </section>
      <section aria-label="Listings">
        <Listings bookableOnly />
      </section>
    </Stack>
  );
}
